export default {
  GET_PLACES_FAILED: 'validation.errors.groupSearch.failedToGetPlaces',
  POSTCODE_FORMAT_ERROR: 'validation.errors.postcode.formatError',
  FIELD_REQUIRED: 'validation.errors.groupSearch.searchTypeUnknown',
};
